import { useDeleteHolidayLocation } from 'src/hooks/holiday-manager/delete-holiday-location.hook';
import { useGetHolidayLocationById } from 'src/hooks/holiday-manager/get-holiday-location-by-id.hook';
import { useGetHolidaySubGroupById } from 'src/hooks/holiday-manager/get-holiday-subgroup-by-id.hook';
import { useUpdateHolidayLocation } from 'src/hooks/holiday-manager/update-holiday-location.hook';
import { useUpdateHolidaySubGroup } from 'src/hooks/holiday-manager/update-holiday-subgroup-by-id.hook';
import { HOLIDAY_MANAGER_PAGES } from 'src/pages/settings/components/holiday-manager/holiday-manager.constants';

export const useGetPropsByCurrentPage = (
  page: string,
  id: string
): { data: object; loading: boolean; onFinish?: (values: any) => void; onDelete?: () => void } => {
  const updateHolidayLocation = useUpdateHolidayLocation();
  const updateHolidaySubGroup = useUpdateHolidaySubGroup();

  const deleteHolidayLocation = useDeleteHolidayLocation();

  const {
    holidayLocation,
    refetch: refetchHolidayLocation,
    loading: holidayLocationLoading,
  } = useGetHolidayLocationById(page === HOLIDAY_MANAGER_PAGES.locationEdit ? id : undefined);
  const { holidaySubGroup, loading: holidaySubGroupLoading } = useGetHolidaySubGroupById(
    page === HOLIDAY_MANAGER_PAGES.details || page === HOLIDAY_MANAGER_PAGES.edit ? id : undefined
  );

  if (page === HOLIDAY_MANAGER_PAGES.locationEdit) {
    return {
      data: holidayLocation,
      loading: holidayLocationLoading,
      onFinish: (values: any) => {
        updateHolidayLocation({
          variables: { payload: { ...values, holidayLocationId: id } },
          onCompleted: refetchHolidayLocation,
        });
      },
      onDelete: () => {
        deleteHolidayLocation({ variables: { holidayLocationId: id } });
      },
    };
  }

  if (page === HOLIDAY_MANAGER_PAGES.details) {
    return {
      data: holidaySubGroup,
      loading: holidaySubGroupLoading,
    };
  }

  if (page === HOLIDAY_MANAGER_PAGES.edit) {
    return {
      data: holidaySubGroup,
      loading: holidaySubGroupLoading,
      onFinish: (values: any) => {
        const holidays = values.holidays.map((holiday: any) => ({
          name: holiday.name,
          dateFrom: holiday.date[0],
          dateTo: holiday.date[1],
        }));
        updateHolidaySubGroup({ variables: { payload: { holidays, holidaySubGroupId: id } } });
      },
    };
  }

  return { data: {}, loading: false };
};
